var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMatchWhistle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#AEB1C8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  d: "M17.266 21.297a4.688 4.688 0 1 0-9.375 0 4.688 4.688 0 0 0 9.375 0m7.105.299a11.8 11.8 0 0 0-1.346-5.786M6.411 11.128l-.798-.798a2.83 2.83 0 1 0-4.003 4.002l.799.799"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#AEB1C8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  d: "M25.781 9.5h-6.406v1.81c0 .683-.554 1.237-1.237 1.237h-1.901A1.237 1.237 0 0 1 15 11.31V9.5h-2.309C6.16 9.5.785 14.76.781 21.29c-.003 6.519 5.28 11.804 11.797 11.804 6.413 0 11.631-5.118 11.793-11.492l14.848-4.148V9.5h-6.407M17.266 4.227V.907M14.31 5.451l-2.347-2.348m8.257 2.348 2.349-2.348"
})));
export default SvgMatchWhistle;